import React, { useContext, useState, useEffect, useRef } from "react";
import { environmentVariables } from "../../../config/env.config";
import testimonialdefault from "../../../Images/testimonialdefault.png";
import avatarImage from "../../../Images/minimarketproducticon.png";
import "./../Updatedcss/BusinessChangeBlockUpdatedStyle.css";
import { useFormik } from "formik";
import * as Yup from "yup";
import styled from "styled-components";
import { currencyContext } from "../../../context/currencyContext.js";
import axios from "axios";
import Swal from "sweetalert2";
import { toast } from "react-toastify";
import { businessObjContext } from "../../../context/businessObjContext.js";
import { userContext } from "../../../context/userContext.js";
import { getCurrencyData } from "../../../utils/utility.js";
import { useTranslation } from "react-i18next";

const FormikErrorStyle = styled.div`
font-size:11px;
color: #ff3333;
text-align: justify;
    padding-bottom: 10px;
`;


const restaurantDishMenuForm = ({
  formCount,
  restaurantData,
  setIsAddTestimonialDisable,
  setRestaurantData,
  dishCategoryArray,
  handleFetchminiproductById,
  handleSubmitWithoutTabChange,
  index,
  removeForm,
  servicesArray,
  formikData
}) => {
  const { t } = useTranslation();
  const fileInputRef = useRef();
  const selectElementRef = useRef();
  const openFileInput = () => {
    fileInputRef.current.click();
  };
  const { businessObjData } = useContext(businessObjContext);
  const { userData, setUserData } = useContext(userContext);

  const baseUrl = environmentVariables?.apiUrl;
  const [image, setImage] = useState(null);
  const [imgGalleryArrayPreview, setImgGalleryArrayPreview] = useState([]);
  const [imgGalleryArray, setImgGalleryArray] = useState([]);
  const [productId, setProductId] = useState(null);
  const [addBtnDisable, setAddBtnDisable] = useState(false);
  const { currencyObjData } = useContext(currencyContext);
  const [priceArray, setPriceArray] = useState([])
  const [quantityArray, setQuantityArray] = useState([])
  const [newData, setnewData] = useState({
    price: '',
    quantity: ''
  })
  const [loading, setLoading] = useState(false);

    const [data, setData] = useState({
    formCount: formCount,
    image: null,
    name: "",
    price: [],
    category: "enquiry",
    imageView: null,
    isImageUpload: true,
    quantity: [],
    service: ""
  });

  const addPriceQuantity = () => {
    if (newData.price && newData.quantity) {
      const updatePrice = priceArray;
      const updateQuantity = quantityArray;
      updatePrice.push(newData.price)
      updateQuantity.push(newData.quantity)
      setPriceArray(updatePrice)
      setQuantityArray(updateQuantity)
      setnewData({ price: "", quantity: "" });
    };
  }

  const removePriceQuantity = (index) => {
    setPriceArray((prev) => prev.filter((_, i) => i !== index));
    setQuantityArray((prev) => prev.filter((_, i) => i !== index));
  };
  

  const handleEditProduct = () => {
    setData({ ...data, isImageUpload: true });
    setImage(restaurantData[index]?.dish_image);
    setAddBtnDisable(false);
    setProductId(restaurantData[index]?.id)
  }
  const getImage = (data) => {
    if (data["imageView"]) {
      return data["imageView"];
    } else {
      if (data["image"]) {
        if (data["image"] != "null") {
          return `${environmentVariables?.s3UrlBackendUrl}${data["image"]}`;
        } else {
          return environmentVariables?.s3TestimoinalDefaultImage;
        }
      } else {
        return avatarImage;
      }
    }
  };

  const validationSchema = Yup.object({
    name: Yup.string()
      // .matches(/^[a-zA-Z0-9 ,.?\/()&@$‘’'"_\-\\\"\n\r!#$%&\(\)\-\+\[\]\{\};:'“”,.~@\/?]*$/, "Only ‘,.?-_/@$&’ characters are allowed")
      .matches(/^[\u0600-\u06FFa-zA-Z0-9 ,.?\/()&@$‘’'"_\-\\\"\n\r!#$%&\(\)\-\+\[\]\{\};:'“”,.~@\/?]*$/, `${t("Only")} ‘,.?-_\\/@$&’ ${t("characters_are_allowed")}`)
      .required(t("Name_required"))
      .min(2, t("Minimum_2_characters_required")),
    category: Yup.string(),
  });

  const formik = useFormik({
    initialValues: {
      name: data.name || "",
      price: data.price,
      category: data.category || "",
      quantity: data.quantity || "",
      service: data.service || "",
    },
    validationSchema: validationSchema,
    enableReinitialize: true,
    onSubmit: (values) => {
    },
  });


  const handleAddService = (values) => {
    setLoading(true);

    let formData = new FormData();
    if(!!image){
      if(typeof image!="string"){
        for (let i = 0; i < image.length; i++) {
          formData.append("dish_image", image[i], image[i].name);
        }
      }else {
        formData.append("dish_image",image);
      }
    }
    formData.append("dish_name", values.name);
    formData.append("dish_category", values.service);
    formData.append("dish_type", values.category);
    formData.append("dish_price", priceArray.join(","));
    formData.append("dish_quantity", quantityArray.join(","));
    formData.append("businessId", businessObjData?.id);
  
    let config = {
      method: productId ? "put" : "post",
      url: productId
        ? `${environmentVariables?.apiUrl}api/v1/business/updateRestaurentProduct?id=${productId}`
        : `${environmentVariables?.apiUrl}api/v1/business/addrestaurentproducts`,
      data: formData,
      headers: {
        _token: userData?.token,
      },
    };
  
    axios
      .request(config)
      .then((response) => {
        toast.success(`Product ${productId ? "updated" : "added"} successfully`, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 1000,
        });
  
        setAddBtnDisable(true);
        setIsAddTestimonialDisable(false);
        setData({
          name: "",
          price: [],
          category: "enquiry",
          quantity: [],
          image: null,
          imageView: null,
          service: "",
        });
  
        handleFetchminiproductById(businessObjData?.id);
        setProductId(null);
      })
      .catch((error) => {
        toast.error(error?.response?.data?.message || error?.message);
        console.log(error);
      }).finally(() => {
        setLoading(false);
      });
  };

  const handleChangeImage = (e) => {
    setImage(e.target.files);
    if (e.target.files.length > 0) {
      const reader = new FileReader();
      reader.onload = () => {
        setData({ ...data, imageView: reader.result });
      };
      reader.readAsDataURL(e.target.files[0]);
    }
  };

  useEffect(() => {
    let currentForm = restaurantData[index];

    let priceData = currentForm?.menu_prices?.dish_price || [];
    let quantityData = currentForm?.menu_prices?.dish_quantity || [];

    priceData = Array.isArray(priceData) ? priceData : [priceData];
    quantityData = Array.isArray(quantityData) ? quantityData : [quantityData];

    setData({
      name: currentForm?.dish_name || currentForm?.name,
      price: priceData,
      category: currentForm?.dish_type || currentForm?.category,
      quantity: quantityData,
      image: currentForm?.dish_image,
      gallery: currentForm?.dish_image,
      imageView: currentForm?.imageView,
      formCount: index,
      isImageUpload: currentForm?.isImageUpload,
      service: currentForm?.dish_category || currentForm?.service,
    });

    setPriceArray(priceData);
    setQuantityArray(quantityData);

  }, [restaurantData, index]);


  const deleterestaurantProduct = async (id, business_id) => {
    try {
      const response = await axios.delete(`${baseUrl}api/v1/business/deleteRestaurentProduct`, {
        data: { id, business_id },
        headers: {
          _token: userData?.token,
        },
      });
      return response.data;
    } catch (error) {
      console.error("Error deleting product:", error);
      return { success: false, message: error.message };
    }
  };


  const handleRemoveForm = async (index) => {
    const { id, business_id } = restaurantData[index];

    Swal.fire({
      title: t("Are_you_sure"),
      text: t("You_wont_be_able_to_revert_this"),
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: t("Yes_delete_it"),
      cancelButtonText: t("Cancel"),
    }).then(async (result) => {
      if (result.isConfirmed) {
        if (restaurantData[index]?.isNew) {
          removeForm(index);
          Swal.fire(t("Deleted!"), t("The_product_deleted"), t("Success"));
        } else {
          const result = await deleterestaurantProduct(id, business_id);
          if (result.success) {
            removeForm(index);
            Swal.fire(t("Deleted!"), t("The_product_deleted"), t("Success"));
          } else {
            console.error(t("Failed_delete_product"), result.message);
            Swal.fire(t("Error!"), t("Failed_delete_product"), t("Error"));
          }
        }
      }
    });
  };

  return (
    <div
      key={`form-${formCount}`}
      className="col-12"
      id="AddNewStyleFormfieldpad"
    >
      <div className="serviceboxedittesti MobileviewServices">
        <i
          className="fa-solid fa-circle-xmark crossedit"
          onClick={() => handleRemoveForm(index)}
        >
          {" "}
        </i>

        <div className="boxbanner">
          <label className="imgrec" style={{ fontSize: "12px" }}>{t("Minimkt_size")}</label>
          <div className="bannerboxedittesti ">
            <img
              style={{
                cursor:
                  data["isImageUpload"] && !addBtnDisable
                    ? "pointer"
                    : "inherit",
              }}
              onClick={() => {
                data["isImageUpload"] && !addBtnDisable
                  ? openFileInput()
                  : null;
              }}
              src={getImage(data)}
              className="mx-auto d-block img-fluid"

            />
            <i
              style={{
                display:
                  data["isImageUpload"] && !addBtnDisable ? "block" : "none",
              }}
              onClick={() => {
                data["isImageUpload"] && !addBtnDisable
                  ? openFileInput()
                  : null;
              }}
              id="uploadicon"
              className="fa fa-solid fa-upload"
            ></i>
          </div>
          {data["isImageUpload"] && !addBtnDisable && (
            <input
              ref={fileInputRef}
              style={{ display: "none" }}
              onChange={(e) => {
                handleChangeImage(e);
              }}
              className="form-control"
              type="file"
              placeholder={`${t("Title")}`}
              accept=".png, .jpg, .jpeg"
            />
          )}
        </div>

        <div className="AddDetailsTextimonialphnview">
          <div className="col-md-12">
            <select
              name="service"
              className="form-select"
              disabled={!data["isImageUpload"]}
              {...formik.getFieldProps("service")}
            >
              <option value="" disabled >{t("Select_category")}</option>
              {/* <option value="stater">stater</option> */}

              {dishCategoryArray.map((service) => (
                !!service?.id &&
                <option key={service?.name} value={service?.id}>
                  {/* {service?.name?.charAt(0)?.toUpperCase() + service?.name?.slice(1)} */}
                  {t(service?.name)}
                </option>
              ))}
            </select>
            {formik.touched.service && formik.errors.service ? (
              <div className="text-danger">{formik.errors.service}</div>
            ) : null}
          </div>
          <div className="" style={{ fontSize: "16px", fontWeight: "500", }}>
            {data["isImageUpload"] && !addBtnDisable ? (
              <div>
                <input
                  {...formik.getFieldProps("name")}
                  className="form-control"
                  type="text"
                  placeholder={`${t("Name")}`}
                />
                {formik.touched.name && formik.errors.name ? (
                  <FormikErrorStyle>{formik.errors.name}</FormikErrorStyle>
                ) : null}
              </div>
            ) : (
              <div>{data["name"] == "undefined" ? "" : data["name"]}</div>
            )}
          </div>

          <div key={index} style={{ display: "flex", gap: "10px", marginBottom: "10px", justifyContent: "center" }}>
            {data["isImageUpload"] && !addBtnDisable ? (

              <div style={{ display: "flex", gap: '8px' }}> <input
                type="number"
                className="form-control"
                name='price'
                placeholder={`${t("Price_in")} ${currencyObjData?.name || "INR"}`}
                value={newData.price}
                onChange={(e) =>
                  setnewData((prevData) => ({
                    ...prevData,
                    price: e.target.value ? parseFloat(e.target.value) : ""
                  }))
                }
                style={{paddingInline:"15px", marginBottom:"0"}}
              />

                <input
                  type="text"
                  className="form-control"
                  name='quantity'
                  placeholder="Quantity"
                  value={newData.quantity}
                  onChange={(e) =>
                    setnewData((prevData) => ({
                      ...prevData,
                      quantity: e.target.value
                    }))
                  }
                  style={{paddingInline:"15px", marginBottom:"0"}}
                />
                <div className="btn btn-cu addQtty" onClick={addPriceQuantity}>+</div>
              </div>

            ) : (
              <></>
            )}
          </div>


          {(priceArray.length > 0 && quantityArray.length > 0) && (
            <ul>
              {priceArray.map((item, index) => (
                <div key={index} className="crosstext">
                  {item && (
                    <i
                      class="fa-solid fa-circle-xmark"
                      onClick={() => removePriceQuantity(index)}
                    ></i>
                  )}
                  <li>{item} - {quantityArray[index]}</li>
                </div>
              ))}
            </ul>
          )}

          {data["isImageUpload"] && !addBtnDisable ? (
            <div className="form-group" style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
              <label style={{ display: 'flex', alignItems: 'center', gap: '5px', justifyContent: 'center' }}>
                <input
                  type="radio"
                  name="category"
                  value="veg"
                  checked={formik.values.category === "veg"}
                  onChange={formik.handleChange}
                />
                {t("Veg")}
              </label>
              <label style={{ display: 'flex', alignItems: 'center', gap: '5px', justifyContent: 'center' }}>
                <input
                  type="radio"
                  name="category"
                  value="nonveg"
                  checked={formik.values.category === "nonveg"}
                  onChange={formik.handleChange}
                />
                {t("Non_veg")}
              </label>
              {formik.touched.category && formik.errors.category ? (
                <FormikErrorStyle>{formik.errors.category}</FormikErrorStyle>
              ) : null}
            </div>
          ) : (
            <div>{data["category"]}</div>
          )}

          {data["isImageUpload"] && !addBtnDisable ? <></> : <><button onClick={() => { handleEditProduct() }} type="button" class="btn btn-cu addbuttonedit2">{t("Edit")}</button></>}


          {data["isImageUpload"] && !addBtnDisable ? (
            <button
              type="button"
              disabled={productId ? formik.isValid ? false : true : (!formik.isValid || !formik.values.name
                || !formik.values.category || !formik.values.service || addBtnDisable || priceArray.length === 0 ||
                  quantityArray.length === 0)
              }
              onClick={() => {
                formik.handleSubmit();
                handleAddService({
                  name: formik.values.name,
                  price: priceArray,
                  category: formik.values.category,
                  image: image,
                  imageView: data.imageView,
                  isImageUpload: data.isImageUpload,
                  gallery: imgGalleryArray,
                  quantity: quantityArray,
                  service: formik.values.service,
                });
              }}
              className="btn btn-cu editbutton editButtonTextimonial"
            >
              {loading ? "Adding..." : t("Add")}
            </button>
          ) : (
            <></>
          )}
        </div>
      </div>
    </div>
  );
};

export default restaurantDishMenuForm;
